import React, { memo, useEffect, useState } from 'react';

import { api } from '../../../services/api';
import { session } from '../../../services/session';

import placeholderImage from '../../../images/logo_placeholder.png';
import { formatValue, handleImageError } from '../../base/common/utils';

import './detail-banner.scss';

const paymentModelLabels = {
  ROI: 'CPA+',
  CPC: 'Flat EPC',
};

const roiRecLabels = {
  true: 'Enabled',
  false: 'Disabled',
};

const DetailBanner = memo(({ strategyId, propData }) => {
  const [data, setData] = useState({});
  const endpoint = '/api/v0/admins/stats/merch_ed/overview';

  useEffect(() => {
    getData();
  }, [propData]);

  async function getData() {
    if (propData) {
      return setData(propData);
    }
    const params = {
      merch_id: session.orgId,
    };
    const dataResp = await api.get(endpoint, params);
    setData(dataResp.data.data[0].stats);
  }

  function getPricingModel() {
    if (!data.pricing_model || !data.is_active) {
      return [null, null];
    }
    const isFlatRateMerchant = data.pricing_model === 'EPP' && data.cpc !== null;
    const flatOrCpc = isFlatRateMerchant || data.pricing_model === 'CPC';
    const pricingModel = flatOrCpc ? 'CPC' : 'ROI';
    const pricingModelValue =
      pricingModel === 'CPC'
        ? formatValue(data.cpc, 'currency')
        : formatValue(data.roi, 'multiple');

    return [pricingModel, pricingModelValue];
  }

  const [pricingModel, pricingModelValue] = getPricingModel();
  const monthlyBudget = strategyId ? (
    <div>
      {data.total_budget_usd && data.is_active
        ? formatValue(data.total_budget_usd, 'currency', 'monthly_budget_usd')
        : 'Not Defined'}
    </div>
  ) : (
    <div>
      {data.monthly_budget_usd && data.is_active
        ? formatValue(data.monthly_budget_usd, 'currency', 'monthly_budget_usd')
        : 'Not Defined'}
    </div>
  );

  return (
    <div className="detail-banner">
      <div className="logo">
        <img
          src={data.logo_url || placeholderImage}
          alt="merchant_logo"
          onError={e => handleImageError(e, placeholderImage)}
        />
      </div>
      <div className="merchant-details">
        <div className="detail-header">Merchant Details</div>
        <div className="details">
          <span className="detail">
            <div>Conversions Captured</div>
            <div>{data.is_active ? data.conversions_captured : '-'}</div>
          </span>
          <span className="detail">
            <div>ROI Rec</div>
            <div>{data.is_active ? roiRecLabels[data.roi_rec_enabled] : '-'}</div>
          </span>
        </div>
      </div>
      <div className="evergreen-strategy">
        <div className="detail-header">
          {strategyId ? 'Campaign Details' : 'Evergreen Strategy'}
        </div>
        <div className="details">
          <span className="detail">
            <div>Pricing Model</div>
            <div>{pricingModel ? `${pricingModel} ${pricingModelValue}` : '-'}</div>
          </span>
          <span className="detail">
            <div>Payment Model</div>
            <div>{paymentModelLabels[pricingModel] || '-'}</div>
          </span>
          <span className="detail">
            <div>Daily Budget</div>
            <div>
              {data.daily_budget_usd && data.is_active
                ? formatValue(data.daily_budget_usd, 'currency', 'daily_budget_usd')
                : 'Not Defined'}
            </div>
          </span>
          <span className="detail">
            <div>{strategyId ? 'Total' : 'Monthly'} Budget</div>
            {monthlyBudget}
          </span>
        </div>
      </div>
    </div>
  );
});

export default DetailBanner;
